export const computeNet = (longValue, shortValue) => {
  const longNum = Number(longValue) || 0;
  const shortNum = Number(shortValue) || 0;
  return longNum - shortNum;
};

export const computeNetPctOI = (netValue, openInterest) => {
  const netNum = Number(netValue) || 0;
  const oiNum = Number(openInterest) || 0;
  if (!oiNum) {
    return 0;
  }
  return (netNum / oiNum) * 100;
};

export const computeZScores = (series) => {
  if (!Array.isArray(series) || series.length === 0) {
    return [];
  }
  const values = series.map((value) => Number(value) || 0);
  const mean = values.reduce((sum, value) => sum + value, 0) / values.length;
  const variance = values.reduce((sum, value) => sum + (value - mean) ** 2, 0) / values.length;
  const std = Math.sqrt(variance);
  if (!std) {
    return values.map(() => 0);
  }
  return values.map((value) => (value - mean) / std);
};

export const computePercentiles = (series) => {
  if (!Array.isArray(series) || series.length === 0) {
    return [];
  }
  const values = series.map((value) => Number(value) || 0);
  const sorted = values.slice().sort((a, b) => a - b);
  const n = sorted.length;
  return values.map((value) => {
    const less = sorted.filter((item) => item < value).length;
    const equal = sorted.filter((item) => item === value).length;
    const rank = less + equal * 0.5;
    return (rank / n) * 100;
  });
};

const INSIGHTS = {
  FX_SQUEEZE:
    'Leveraged Funds at −2σ net short + Asset Managers long → upside squeeze risk.',
  TREND_CONFIRMATION:
    'Asset Managers increasing net longs with rising OI → trend has institutional backing.',
  FALSE_BREAKOUT:
    'Price breaks out but Net % OI falls → move likely flow-driven, not structural.',
  EXHAUSTION:
    'Both Asset Managers and Leveraged Funds at 90th percentile net long → upside crowded.',
  DEALER_TELL:
    'Dealers sharply reducing net shorts → client flow has flipped.',
};

// Priority order: FX squeeze > Exhaustion > False breakout > Trend confirmation > Dealer tell.
export const getPositioningInsight = (context) => {
  if (!context) {
    return null;
  }
  const {
    leveragedZScore,
    assetNet,
    assetPercentile,
    leveragedPercentile,
    priceBreakout,
    netPctOIChange,
    assetNetChange,
    openInterestChange,
    dealerNetShortChange,
  } = context;

  // FX squeeze: extreme leveraged net short + asset managers net long.
  if (leveragedZScore <= -2 && assetNet > 0) {
    return INSIGHTS.FX_SQUEEZE;
  }

  // Exhaustion: both Asset Managers and Leveraged Funds crowded long.
  if (assetPercentile >= 90 && leveragedPercentile >= 90) {
    return INSIGHTS.EXHAUSTION;
  }

  // False breakout: price breaks range but net % OI is falling.
  if (priceBreakout && netPctOIChange < 0) {
    return INSIGHTS.FALSE_BREAKOUT;
  }

  // Trend confirmation: asset managers adding net long with rising OI.
  if (assetNetChange > 0 && openInterestChange > 0) {
    return INSIGHTS.TREND_CONFIRMATION;
  }

  // Dealer tell: net shorts reducing (net short change negative).
  if (dealerNetShortChange < 0) {
    return INSIGHTS.DEALER_TELL;
  }

  return null;
};
